import Autocomplete, {
  AutocompleteRenderOptionState
} from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { SyntheticEvent } from 'react';

export type Props<T> = {
  label: string;
  options: T[];
  value?: T | null;
  defaultValue?: T | null;
  idProperty: string;
  disabled?: boolean;
  onSelected: (option: T | null) => void;
  onChange?: (event?: SyntheticEvent<any>) => void;
  fullWidth?: boolean;
  variant?: 'outlined' | 'standard' | 'filled';
  renderOption?: (
    props: React.HTMLAttributes<HTMLLIElement>,
    option: T,
    state: AutocompleteRenderOptionState
  ) => React.ReactNode;
  disableClearable?: boolean;
};

export default function CustomAutocomplete<T extends { label: string }>(
  props: Props<T>
) {
  const {
    label,
    options = [],
    value,
    defaultValue,
    idProperty = 'id',
    fullWidth = false,
    disabled,
    onChange,
    onSelected,
    renderOption,
    variant = 'standard',
    disableClearable = false
  } = props;

  return (
    <Autocomplete
      value={value}
      defaultValue={defaultValue}
      autoHighlight
      disableClearable={disableClearable}
      options={options}
      onChange={(e, value: T | null) => onSelected(value)}
      renderInput={(params) => (
        <TextField
          {...params}
          variant={variant}
          size="small"
          label={label}
          fullWidth={fullWidth}
          sx={{ width: fullWidth ? '100%' : 220 }}
          onChange={onChange}
        />
      )}
      renderOption={renderOption}
      isOptionEqualToValue={(a, b) => a[idProperty] === b[idProperty]}
      disabled={disabled}
      getOptionLabel={(option) => option.label}
    />
  );
}
